/** @jsx jsx */
import { jsx } from "theme-ui"
import styled from "styled-components"
import { SingleDatePicker } from "react-dates"
import theme, { rem } from "@src/theme"

const CalendarInput = ({
  name,
  error,
  onBlur,
  required,
  label,
  value,
  focused,
  onFocusChange,
  onChange,
}) => (
  <label
    htmlFor={name}
    sx={{
      display: "block",
    }}
  >
    {label && (
      <Label is="span">
        {label}
        {required && "*"}
      </Label>
    )}

    <SingleDatePicker
      date={value}
      focused={focused}
      onDateChange={onChange}
      onFocusChange={onFocusChange}
      numberOfMonths={1}
      onBlur={onBlur}
      ariaLabel={name}
      displayFormat="DD/MM/YY"
    />
    {error && <p sx={{ color: "rainbowRed", mt: 1, mb: 0 }}>{error}</p>}
  </label>
)

export default CalendarInput

const Label = styled.span`
  display: block;
  font-size: ${rem(18)};
  margin-bottom: ${rem(14)};
  font-family: ${theme.fonts.heading};
  font-weight: 900;
  text-transform: uppercase;
`
